import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phulucxedien from "components/Tonghopbaocao/Phulucxedien/Phulucxedien.js";
export default function PLxedien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Mẫu báo cáo phụ lục xe điện",
            tabContent: <Phulucxedien />,
          },
        ]}
      />
    </div>
  );
}
